import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, LOCALE_ID, provideZoneChangeDetection, provideAppInitializer, inject, ErrorHandler } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { LoggerModule, NgxLoggerLevel, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { ClientLogServerService } from './app/ui-framework/global-services/logging/client-log-server.service';
import { authInterceptor } from './app/ui-framework/global-services/interceptors/request-formatter.interceptor';
import { AppInitService } from './app/ui-framework/global-services/app-init/app-init.service';
import { GlobalErrorHandlerService } from './app/ui-framework/global-services/error-handler/error-handler.service';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),

    { provide: MAT_DATE_LOCALE, useValue: 'en-IN' },
    { provide: LOCALE_ID, useValue: 'en-IN' },

    importProvidersFrom(OverlayModule),
    importProvidersFrom(A11yModule),
    importProvidersFrom(NgxSpinnerModule.forRoot({ type: 'ball-clip-rotate-multiple' })),
    importProvidersFrom(BrowserAnimationsModule),

    importProvidersFrom(LoggerModule.forRoot({
      level: NgxLoggerLevel.ERROR,
      colorScheme: [ 'gray','silver','blue','gray','orange','red','red' ],
      enableSourceMaps: true
    })),
    { provide: TOKEN_LOGGER_SERVER_SERVICE, useClass: ClientLogServerService },

    provideAppInitializer(() => inject(AppInitService).load()),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService }
  ]
});


  ModuleRegistry.registerModules([ AllCommunityModule ]);
